import axios, { AxiosInstance } from "axios";
import { toast } from "@outpave/ds";
import { getInvoicePayToken } from "utils/invoices/invoicePayToken";
import { HttpStatus } from "enums/HttpStatus";

declare module "axios" {
  export interface AxiosRequestConfig {
    suppressAuthToast?: boolean;
  }
}

const contactHttpClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Attach Contact JWT Token if present
contactHttpClient.interceptors.request.use(
  (config) => {
    // Read the contact’s JWT from localStorage:
    const token = localStorage.getItem("CONTACT_JWT_TOKEN");
    if (token) {
      config.headers = config.headers ?? {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Contact sessions prove identity; pay tokens grant access to one invoice.
    const payToken = getInvoicePayToken();
    if (payToken) {
      config.headers = config.headers ?? {};
      config.headers["X-Pay-Token"] = payToken;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// Clear token if it is expired or invalid
contactHttpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (
      (status === HttpStatus.UNAUTHORIZED || status === HttpStatus.FORBIDDEN) &&
      !error.config?.suppressAuthToast
    ) {
      toast.dismiss();
      toast.error(
        "You are not authorized. Please verify access and try again.",
      );
    }
    return Promise.reject(error);
  },
);

export default contactHttpClient;
